import BaseMixin from '@/views/mixin.vue';
import compSearch from './search';
import compInventory from '../stock';
import { mapState, mapGetters } from 'vuex';
import {
  HttpGetChannelByManageList,
  HttpBatchDeleteByManage,
  HttpBatchActivationByManage,
  HttpBatchSetSaleStatus,
  HttpGetCodeByLineId,
  HttpPushStock
} from '@/service/products/channel';
import { Icon } from 'view-design';
import compErpsku from './comperpsku'
import compSyncAsin from './compsycnasin';
import compIndex from '../update';

export default {
  mixins: [BaseMixin],
  components: {
    compSearch,
    compIndex,
    compErpsku,
    compInventory,
    compSyncAsin,
  },
  data() {
    return {
      isSuper: this.$store.state.userinfo.isSuper,
      fudingdan: 0,
      channelInfo: false,
      erpskuCodeList: []
    };
  },
  watch: {
    data: {
      immediate: true,
      async handler(val) {
        if (!val || !val.length) return;
        
        let productIdList = new Set();
        this.data.map(item => {
          if (item.productChannelRelateList && item.productChannelRelateList.length > 0) {
            item.productChannelRelateList.map(cItem => {
              productIdList.add(cItem.productId);
            });
          } else {
            productIdList.add(item.productId);
          }
        });

        await HttpGetCodeByLineId({ productIds: Array.from(productIdList).join(',') })
          .then(res => {
            this.erpskuCodeList = new Map();
            res.data.map(item => {
              this.erpskuCodeList.set(item.id, item.erpSkuCode);
            });
          })
          .catch(err => {
            this.$VMessage.error(err.message);
          });
      }
    }
  },
  created() {
    this.channelInfo = this.handleAuth('erp.productChannel.delete');
    this.productChannelSet = this.handleAuth('erp.productChannel.adminSet');
  },
  methods: {
    httpList: HttpGetChannelByManageList,
    
    handleOperates(data, type, row) {
      this.operate = {};
      switch (type) {
        case 'query':
          this.operate = {
            title: this.$t('global.common.operation_see', { defaultValue: '查看' }),
            show: true,
            width: 1200,
            component: "compIndex",
            activeids: data,
            querytype: 'query'
          };
          break;
        case 'disabled':
          this.checkedId = !data ? this.checkedId : [data];
          if (this.checkedId.length == 0) {
            this.$Message.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            return;
          } else {
            this.showDel = true;
            this.operate = {
              title: this.$t('global.common.inactive', { defaultValue: '停用' }),
              desc: this.$t('erp.channel.confirm_inactive', { defaultValue: `确定停用操作？` }),
              type,
              id: data,
            };
          }
          break;
        case 'queryBlank':
          const url = this.$router.resolve({
              name: 'prochannelUpdateAdmin',
              params: { type: 'query' },
              query: { id: data },
          });
          window.open(url.href, '_blank');
          break;
        case 'actived':
          this.checkedId = !data ? this.checkedId : [data];
          if (this.checkedId.length == 0) {
            this.$Message.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            return;
          } else {
            this.showDel = true;
            this.operate = {
              title: this.$t('erp.channel.active', { defaultValue: '激活' }),
              desc: this.$t('erp.channel.confirm_active', { defaultValue: `确定激活操作？` }),
              type,
              id: data,
            };
          }
          break;
        case 'delete':
          this.showDel = true;
          this.operate = {
            title: this.$t('global.common.delete', { defaultValue: '删除' }),
            desc: this.$t('erp.channel.confirm_delete', { defaultValue: `删除后不可恢复，确定删除？` }),
            type,
            id: data,
          };
          break;
        case 'inventory':
          this.operate = {
            title: this.$t("global.common.operation_see", { defaultValue: '查看' }),
            show: true,
            width: 800,
            component: "compInventory",
            comperpsku: data,
            querytype: 'query'
          };
          break;
        case 'editerpsku': {
            this.operate = {
                show: true,
                title: this.$t('erp.channel.edit_sku', { defaultValue: '编辑ERPSKU' }),
                width: 650,
                showFooter: false,
                component: "compErpsku",
                itemid: data
            }
            break
        }
        case 'add': {
            this.$router.push({
                name: 'prochannelUpdateAdmin',
                params: { type: 'add' },
            });
            break;
        }
        case 'syncAsin':
          this.operate = {
            show: true,
            title: '同步ASIN',
            width: 650,
            showFooter: false,
            component: "compSyncAsin",
          };
          break;
      }
    },

    async batchOpearte() {
      let request,
        { type, id } = this.operate,
        params = {},
        callback = (res) => {
          this.$Message.success(res.message);
        };

      switch (type) {
        case 'disabled':
          request = HttpBatchActivationByManage;
          params = { ids: this.checkedId.join(',') || id, action: "N" };
          break;
        case 'actived':
          request = HttpBatchActivationByManage;
          params = { ids: this.checkedId.join(',') || id, action: "Y" };
          break;
        case 'topframe':
          request = HttpBatchSetSaleStatus;
          params = { ids: this.checkedId.join(','), action: "Hit Shelve" };
          break;
        case 'lowframe':
          request = HttpBatchSetSaleStatus;
          params = { ids: this.checkedId.join(','), action: "Not Sell" };
          break;
        case 'delete':
          request = HttpBatchDeleteByManage;
          params = { ids: this.checkedId.join(',') || id };
          break;
        case 'pushStock':
          request = HttpPushStock;
          params = { id: this.checkedId.join(',') || id };
          break;
      }

      if (!request) return;

      request(params)
        .then(res => {
          this.$Message.success(res.message);
          this.updateList();
        })
        .catch(err => {
          this.$VMessage.error({ content: err.message, duration: 30, closable: true });
        })
        .finally(() => {
          this.showDel = false;
          this.operate = {};
        });
    },

    // 操作下的列表展示内容
    getOperateNodeMap(row) {
      const { id, status, accountFlag } = row;
      return [
        { label: this.$t('global.common.operation_see', { defaultValue: '查看' }), show: true, params: id, operate: 'query' },
        {
                label: this.$t('erp.channel.edit_sku', { defaultValue: '编辑ERPSKU' }),
                show: status === 'Y' && this.productChannelSet,
                params: id,
                operate: 'editerpsku'
            },
        { label: this.$tc('global.common.inactive', 2, { defaultValue: '停用' }), show: status === 'Y' && this.productChannelSet, params: id, operate: 'disabled' },
        { label: this.$t('erp.channel.active', { defaultValue: '激活' }), show: status === 'N' && this.productChannelSet, params: id, operate: 'actived' },
        { label: this.$t('global.common.delete', { defaultValue: '删除' }), show: this.channelInfo == true, params: id, operate: 'delete' }
      ];
    },

    getShowPrice(val) {
      let flag = false;
      this.getCusAccountList.filter(item => {
        if (item.value == val) {
          if (item.attach.type == 'amazon') {
            flag = true;
          }
        }
      });
      return flag;
    },

    getAccountTypeBool(val, type) {
      let flag = false;
      this.getCusAccountList.filter(item => {
        if (item.value == val) {
          if (item.attach.type.includes(type)) {
            flag = true;
          }
        }
      });
      return flag;
    }
  },
  computed: {
    ...mapState('boss', ['warehouseList']),
    ...mapGetters('diction', ['getNewDifferentAllProductList']),
    ...mapGetters("dictionary", ["getOrgList","getCusAccountList"]),
    columns() {
      let datalist = [
        { type: 'selection', width: 60 },
        {
          title: this.$t('global.common.operate', { defaultValue: "操作" }),
          width: 95,
          render: this.getOperateNodes,
        },
        {
            title: this.$t('global.common.organization',{defaultValue:'组织'}),
            width:90,
            render: (h, { row }) => {
                const id = row.orgId;
                const org = this.getOrgList.filter((item) => {
                    return id == item.value
                })[0] || {};
                return <div>
                    <div><span class="font-bold">{org.label}</span></div>
                </div>
            }
        },
        {
          title: this.$t('global.common.channel', { defaultValue: '渠道' }) + '/' + this.$t('erp.product.product_line', { defaultValue: '项目' }) + '/Seller SKU',
          render: (h, { row }) => {
            return (
              <div>
                <div>{row.accountFlag}</div>
                <div><span class="font-bold">{this.findRenderLabel(this.getNewDifferentAllProductList, row.lineId)}</span></div>
                <div>
                  <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.sellerSku}</a>
                  <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><Icon class="margin-left-10 font-14" type="ios-browsers-outline"/></a>
                </div>
              </div>
            );
          },
        },
        {
          title: 'title',
          render: (h, { row }) => {
            return (
              <div>
                <div>{row.title}</div>
              </div>
            );
          }
        },
        {
          title: 'ERPSKU',
          render: (h, { row }) => {
            return (
              <div>
                <div>{row.erpSku}</div>
              </div>
            );
          }
        },
        {
          title: this.$t('global.common.isinactive', { defaultValue: '是否停用' }),
          width: 100,
          render: (h, { row }) => {
            return <div>{row.status == 'Y' ? this.$t('erp.global.no', { defaultValue: '否' }) : this.$t('erp.global.yes', { defaultValue: '是' })}</div>;
          },
        },
        {
          title: this.$t('erp.channel.up_down_status', { defaultValue: '上下架状态' }) + '/' + this.$t('erp.b2c.shipping_method', { defaultValue: '发货方式' }),
          render: (h, { row }) => {
            let saleState;
            switch (row.saleState) {
              case 'Hit Shelve':
                saleState = this.$t('erp.channel.up_staff', { defaultValue: '上架' });
                break;
              case 'Not Sell':
                saleState = this.$t('erp.channel.down_staff', { defaultValue: '下架' });
                break;
              case 'Off Shelve':
                saleState = this.$t('erp.channel.temp_down_staff', { defaultValue: '临时下架' });
                break;
            }
            if (row.saleState === 'Hit Shelve') {
              return (
                <div>
                  <div style="color: green;">{saleState}</div>
                  <div>{row.skuOrderType == 0 ? this.$t('erp.channel.auto', { defaultValue: '自动' }) : this.$t('erp.channel.manual', { defaultValue: '手动' })}</div>
                </div>
              );
            } else {
              return (
                <div>
                  <div style="color: red;">{saleState}</div>
                  <div>{row.skuOrderType == 0 ? this.$t('erp.channel.auto', { defaultValue: '自动' }) : this.$t('erp.channel.manual', { defaultValue: '手动' })}</div>
                </div>
              );
            }
          },
        },
        {
          title: 'Asin',
          render: (h, { row }) => {
              const amazonUrl = `https://www.amazon.com/dp/${row.asin}`;
              return (
                  <div>
                      <div>
                          <a 
                              href={amazonUrl} 
                              target="_blank" 
                              rel="noopener noreferrer"
                              class="font-bold"
                          >
                              {row.asin || '-'}
                          </a>
                      </div>
                  </div>
              );
            },
          },
        {
          title: 'Listing Img',
          render: (h, { row }) => {
            let image = row.imageUrl;
            if (image) {
              return (
                <div>
                  <div style="float: left; cursor: pointer; margin-right: 10px;">
                    <img style="width: 100px; height: 100px;" src={image}></img>
                  </div>
                </div>
              );
            } else {
              return (
                <div>
                  <div><span>-</span></div>
                </div>
              );
            }
          },
        },
        {
          title: 'Price',
          width: 180,
          renderHeader: (h) => {
            return (
              <Tooltip max-width={600} placement="bottom" transfer>
                Price
                <div slot="content">
                  <p>Listing Price: SC（划线价） VC（预期销售价格）建议零售价</p>
                  <p>Your Price: 前台销售价价格-实际（折扣前）</p>
                  <p>Sales Price: 销售价格，折扣后</p>
                  <p>Cost Price: VC 供货价</p>
                  <p>Payment Price: VC 回款价（扣除平台扣减和服务费）</p>
                </div>
              </Tooltip>
            );
          },
          render: (h, { row }) => {
            return (
              <div>
                <div><span class="font-bold">Listing Price:</span> {row.price} {row.currencyCode}</div>
                <div><span class="font-bold">Your Price:</span> {row.yourPrice} {row.currencyCode}</div>
                <div><span class="font-bold">Sales Price: </span> {row.salePrice} {row.currencyCode}</div>
                <div><span class="font-bold">Cost Price: </span> {row.costPrice} {row.currencyCode}</div>
                <div><span class="font-bold">Payment Price: </span> {row.paymentPrice} {row.currencyCode}</div>
              </div>
            );
          }
        },
        {
          title: this.$t('erp.product.total_inventory', { defaultValue: '总库存' }),
          width: 80,
          render: (h, { row }) => {
            return (
              <div>
                <div><a onClick={this.handleOperates.bind(this, { accountFlag: row.accountFlag, sellerSku: row.sellerSku }, 'inventory')}>{row.stockQty == 0 ? row.stockQty : row.stockQty == null ? '--' : row.stockQty}</a></div>
              </div>
            );
          },
        },
        {
          title: this.$t('erp.channel.up_staff', { defaultValue: '上架' }) + '/' + this.$t('global.common.update_time', { defaultValue: '更新时间' }),
          render: (h, { row }) => {
            return (
              <div>
                <div>{row.amazonTime || '-'}</div>
                <div>{row.updatedAt || '-'}</div>
              </div>
            );
          },
        },
      ];
      return datalist;
    },
  },
};